import { render, staticRenderFns } from "./MflTable.vue?vue&type=template&id=29cc788e"
import script from "./MflTable.vue?vue&type=script&lang=js"
export * from "./MflTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports